<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader

    main.primary--text
      v-container
        h1 オリジナルアイテム ダウンロード

        p.text-xs-center(style="font-size:1.2rem;line-height:1.5rem") リモート背景、
          br
          | カメラステッカーを配布しています。
        v-flex.my-4(xs6 md2 offset-xs3 offset-md5)
          v-btn.scroll(block outline flat v-scroll-to="'#tos'" style="margin:0 auto;" color="primary") 利用規約
      //-
        v-container
          h2 ジューシーズ坊や&ココナッツちゃん
            br
            | 2025年カレンダー
          v-layout.my-2.justify-center(row wrap)
            v-flex.notes(xs12)
              v-flex(xs12 lg10 offset-lg1)
                v-card.primary--text.pa-4
                  div(v-for="(item,index) in notes_cal" :key="item.title")
                    i.material-icons.secondary--text
                      | {{item.icon}}
                    p.text-xs-left {{item.title}}
                    ul.my-1
                      li(v-for="(list, index) in item.list") {{ list }}
          v-layout.my-2.justify-center(row wrap)
            v-flex(xs12 lg10 offset-xs0)
              v-card.pa-2
                v-layout.justify-center(row wrap)
                  v-flex.pa-2(v-for="n in 6" :key="'pic' + n" sm4 xs6)
                    a(:href="'static/images/download/calendar/cal_a4_'+ n + '.png'")
                      img(:src="'static/images/download/calendar/cal_a4_'+ n + '_smb.png'" width='100%')
                    v-btn.scroll.mt-1(block flat color="primary" :href="'static/images/download/calendar/cal_a4_'+ n + '.pdf'" :download="'cal_a4_'+ n + '.pdf'" style="margin:0 auto;")
                      i.material-icons.secondary--text
                        | inbox
                      span 印刷用PDF(A4)
                h4.primary--text.mt-2.text-xs-center スマートフォン用
                v-layout.justify-center(row wrap)
                  v-flex.pa-2(v-for="n in 6" :key="'pic' + n" sm2 xs6)
                    a(:href="'static/images/download/calendar/cal_sp_'+ n + '.png'" )
                      img(:src="'static/images/download/calendar/cal_sp_'+ n + '_smb.png'" width='100%')
      v-container
        h2 リモート背景
        v-layout(row wrap)
          v-flex(xs12 lg10 offset-xs0 offset-lg1)
            p.text-xs-center(style="font-size:1.2rem;line-height:1.5rem") オンライン会議等に使用できるリモート背景です。
        v-layout.my-2.justify-center(row wrap)
          v-flex(xs12 lg10 offset-xs0)
            v-card.pa-2
              v-layout.justify-center(row wrap)
                v-flex.pa-2(v-for="n in 4" :key="'pic' + n" sm6 xs6)
                  a(:href="'static/images/download/bg/bg_'+ n + '.png'" )
                    img(:src="'static/images/download/bg/bg_'+ n + '_smb.png'" width='100%')
      v-container
        h2 カメラステッカー
        v-layout(row wrap)
          v-flex(xs12 lg10 offset-xs0 offset-lg1)
            p.text-xs-center(style="font-size:1.2rem;line-height:1.5rem") 画像を保存して、オリジナル画像を使える
              br
              | カメラアプリなどでご自由にお使いください。
        v-layout.my-3.sample(row wrap)
          v-flex(xs12 lg10 offset-lg1)
            v-layout(row wrap)
              v-flex.justify-center(xs4 v-for="i in 3" :key="'sample' + i")
                  img.ma-1(src="static/images/instagram.svg" :style="'backgroundImage:url(../../../../../static/images/sample_' + i + '.jpg)'")
        v-layout.my-2.justify-center(row wrap)
          v-flex.notes(xs12)
            v-flex(xs12 lg10 offset-lg1)
              v-card.primary--text.pa-4
                div(v-for="(item,index) in notes_sticker" :key="item.title")
                  i.material-icons.secondary--text
                    | {{item.icon}}
                  p.text-xs-left {{item.title}}
                  ul.my-1
                    li(v-for="(list, index) in item.list") {{ list }}
          v-flex(xs12 lg10 offset-xs0)
            v-card.mt-3
              v-layout.pic_j.justify-center(row wrap)
                v-flex.mt-5(xs12)
                  h4.primary--text.text-xs-center ジューシーズ坊や
                div.pic.ma-1(v-for="n in 12" :key="'pic' + n")
                  a(:href="'static/images/download/sticker/j_'+ n + '.png'" :download="'sticker/juicies_'+ n + '.png'" )
                    img(:src="'static/images/download/sticker/j_'+ n + '.png'")
              v-layout.pic_c.justify-center(row wrap)
                v-flex.mt-5(xs12)
                  h4.primary--text.text-xs-center ココナッツちゃん
                div.pic.ma-1(v-for="n in 12" :key="'pic' + n")
                  a(:href="'static/images/download/sticker/c_'+ n + '.png'" :download="'sticker/coconuts_'+ n + '.png'" )
                    img(:src="'static/images/download/sticker/c_'+ n + '.png'")
              v-layout.px-2.py-5.justify-center(row wrap)
                v-flex.mt-5(xs12)
                  h4.primary--text.text-xs-center まとめてダウンロード
                    br
                    |
                    span(style="font-size: 1rem;") (zipファイル・PC推奨)
                v-flex.mx-1(md2)
                  v-btn.scroll(block flat color="primary" :href="'static/images/download/sticker/juicies.zip'" :download="'sticker/juicies.zip'" style="margin:0 auto;")
                    i.material-icons.secondary--text
                      | inbox
                    span ジューシーズ坊や
                v-flex.mx-1(md2 offset-md1)
                  v-btn.scroll(block flat color="primary" :href="'static/images/download/sticker/coconuts.zip'" :download="'sticker/coconuts.zip'" style="margin:0 auto;")
                    i.material-icons.secondary--text
                      | inbox
                    span ココナッツちゃん
        v-layout#tos.mt-4.justify-center(row wrap)
          v-flex(xs12)
            v-flex.notes(xs12 lg10 offset-lg1)
              v-card.primary--text.pa-4
                i.material-icons.secondary--text
                  | info
                p.text-xs-left 利用規約
                dl.mt-2(v-for="(item , index) in tos" :key="item.title")
                  dt.mt-1 {{ item.title }}
                  dd
                    span(v-if="item.text") {{ item.text }}
                    ul
                      li(v-for="(list, index) in item.list") {{ list }}
    CommonFooter
    span.footer_pic

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
    this.$vuetify.theme.primary = '#3e2723'
    this.$vuetify.theme.secondary = '#ffcc00'
  },
  data () {
    return {
      notes_cal: [{
        icon: 'collections',
        title: '画像の保存方法',
        list: [
          'お好みの画像を選択して保存してください。',
          'A4版PDFもダウンロードできます。'
        ]
      }],
      notes_sticker: [{
        icon: 'collections',
        title: '画像の保存方法',
        list: [
          'パソコンの方…お好みの画像をクリックするとダウンロードされます。',
          'スマートフォン、タブレットの方…お好みの画像を長押しして保存してください。'
        ]
      }, {
        icon: 'info',
        title: '注意事項',
        list: [
          '画像の使用方法については、各アプリ・ソフトの使用方法に従ってください。',
          'オリジナル画像をステッカーとして使用できないアプリではご使用いただけません。'
        ]
      }],
      tos: [{
        title: '利用条件',
        list: [
          '当素材は、個人利用の範囲で無料でお使いいただけます。',
          'ご利用に際して、報告、クレジット表記の必要はありません。'
        ]
      }, {
        title: '禁止事項',
        text: '以下の場合の利用を禁止します。',
        list: [
          '当素材そのものや改変、加工した素材の再配布、販売。',
          '公序良俗に反する媒体での利用、アダルトコンテンツでの利用、素材のイメージを損なうような利用。',
          '当素材を利用したロゴ制作や商標登録。',
          'その他当社が不適切と判断した場合。'
        ]
      }, {
        title: 'その他',
        list: [
          'ダウンロードした素材によりいかなるトラブルが発生しても、当社は一切責任を負いません。',
          'この規約は予告なく改変することがあります。予めご了承ください。'
        ]
      }]
    }
  }
}

</script>

<style scoped lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Dokdo')

// breakpoint
screen-xs = 600px
screen-sm = 960px
screen-md = 1264px
breakpoint(bpName)
    for name in bpName
        if name == 'lg-up'
            @media only screen and (min-width: screen-md + 1)
                {block}
        if name == 'md-up'
            @media only screen and (min-width: screen-sm + 1)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}

.sample
  img
    background-size contain
    max-width 400px
.notes
  i
    font-size 1.1rem
    float left
    margin-right 5px
  p
    font-weight bold
    font-size 0.9rem
  li
    list-style-type circle
    margin-left 2rem
    font-size 0.8rem
  dl
    dt
      font-size 0.9rem
      margin-left 1.4rem
    dd
      margin-left 1.4rem
      font-size 0.9rem
    span
      font-size 0.9rem
      margin-left 1.4rem
.pic
  border 1px solid #ececec
  border-radius 20%
.pic_j
  img
    width 160px
    +breakpoint(xs)
      width 108px
.pic_c
  img
    width 120px
    margin 20px
    +breakpoint(xs)
      width 88px
      margin 10px
//Footer
.footer_pic
  background url(../../../../../static/images/footer_pic_items.png) no-repeat
  background-position bottom 0 right -15px

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Download/index.vue